/* globals document */

import React, { Component, PropTypes } from 'react';
import { autobind } from 'core-decorators';
import classNames from 'classnames';
import escapeRegex from 'escape-string-regexp';
import { remove as removeDiacritics } from 'diacritics';

import { byIdShape } from 'utils/propTypes';

import Result from './Result';

import './styles.scss';


class Search extends Component {

  static propTypes = {
    chargersById: byIdShape.isRequired,
    onResultClick: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.allChargers = Object.keys(this.props.chargersById);
    this.hoveringResults = false;
    this.focused = false;
    this.state = {
      results: [],
      show: false,
      selected: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.allChargers = Object.keys(nextProps.chargersById);
  }

  @autobind
  onChange(e) {
    const value = e.target.value;
    let results = [];
    if (value.length > 1) results = this.searchChargers(value);
    let selected = results.indexOf(this.state.selected) === -1 ? null : this.state.selected;
    if (results.length === 1) selected = results[0];
    this.setState({
      results,
      show: results.length > 0,
      selected,
    });
  }

  @autobind
  onFocus(e) {
    document.onkeydown = this.onKeyDown.bind(this);
    this.setState({
      show: true,
    });
    let results = [];
    const value = e.target.value;
    if (value.length > 1) results = this.searchChargers(value);
    this.setState({ results });
  }

  @autobind
  onBlur() {
    document.onkeydown = null;
    if (!this.hoveringResults) this.setState({ show: false });
  }

  onKeyDown(e) {
    if (e.keyCode === 38 || e.keyCode === 40) {
      // Up arrow / down arrow
      e.preventDefault();
      let index = 0;
      if (this.state.selected) {
        const currentIndex = this.state.results.indexOf(this.state.selected);
        if (e.keyCode === 38) {
          index = Math.max(currentIndex - 1, 0);
        } else {
          index = Math.min(currentIndex + 1, this.state.results.length - 1);
        }
      }
      this.setState({
        selected: this.state.results[index],
      });
    } else if (e.keyCode === 13) {
      // Return key
      e.preventDefault();
      this.input.blur();
      if (this.state.selected) this.handleResultClick(e, this.state.selected);
    } else if (e.keyCode === 27) {
      // Esc key
      e.preventDefault();
      this.input.blur();
    }
  }

  @autobind
  onReset() {
    this.input.focus();
    this.setState({ results: [] });
  }

  searchChargers(q) {
    return this.allChargers.filter((pk) => {
      const charger = this.props.chargersById[pk];
      const re = new RegExp(`(?:^|\\s)${escapeRegex(removeDiacritics(q))}`, 'i');
      return re.test(charger.title_ascii || charger.title);
    });
  }

  @autobind
  handleResultClick(e, charger) {
    this.props.onResultClick(charger);
    this.input.value = this.props.chargersById[charger].title;
    this.setState({ show: false });
  }

  render() {
    return (
      <div className='search' styleName='search'>

        <form className='navbar-form' role='search' onReset={this.onReset} styleName='form'>
          <div className='form-group'>

            <input
              ref={(c) => { this.input = c; }}
              name='search'
              className='form-control'
              placeholder='Find a charger'
              onChange={this.onChange}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
            />

            <button
              type='reset'
              className={classNames('btn', 'btn-default', 'reset', {
                active: this.state.show,
              })}
              styleName='reset'
            >
              <span>&times;</span>
            </button>

          </div>
        </form>

        <div styleName='results-wrapper' className={classNames({ active: this.state.show })}>

          <ul
            className={classNames('list-group', 'results')}
            styleName='results'
            onMouseOver={() => { this.hoveringResults = true; }}
            onMouseOut={() => { this.hoveringResults = false; }}
          >
            { this.state.results.map((pk) => {
              const charger = this.props.chargersById[pk];
              return (
                <Result
                  key={charger.pk}
                  charger={charger}
                  search={this.input.value}
                  selected={this.state.selected === pk}
                  onClick={this.handleResultClick}
                />
              );
            }) }
          </ul>

        </div>

      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Header/Search/index.jsx